import { apiClient } from "./apiClient";

export const duplicatesApi = {
  list: () => apiClient.get("/duplicates").then((r) => r.data),

  // Payments that may have been entered twice (V147). Business feature.
  listPayments: () => apiClient.get("/duplicates/payments").then((r) => r.data),
  // both_real | reverse_second. Nothing is deleted.
  resolvePayment: (flagId, answer) =>
    apiClient.post(`/duplicates/payments/${flagId}/resolve`, { answer }).then((r) => r.data),

  // One call, three answers -- none of which delete anything. See
  // services/duplicates.py for what each one does to the records.
  // duplicateLogIds names WHICH entries were the same event, for a window
  // holding three or more. Omitted means all of them -- what the
  // two-entry case has always meant.
  resolve: (suspicionId, answer, duplicateLogIds = null, assignToUserId = null) =>
    apiClient
      .post(`/duplicates/${suspicionId}/resolve`, {
        answer,
        ...(duplicateLogIds && duplicateLogIds.length
          ? { duplicate_log_ids: duplicateLogIds }
          : {}),
        ...(assignToUserId ? { assign_to_user_id: assignToUserId } : {}),
      })
      .then((r) => r.data),
};
